import React, { useCallback } from 'react';
import type {
  MasonryEngineNodeAction,
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { useMasonryEngineActionEmitter } from '@leagueplatform/masonry-engine';
import { RegionSelectionHome } from 'components/region-selection/containers/region-selection-home';

export type RegionBannerNodeProps = Partial<{
  title: string;
  buttonLabel: string;
  buttonAction: string;
  region: {
    planName: string;
    planType: string;
    groupNumber: string;
    clientNumber: string;
    brandUBK: string;
  };
}>;

export type RegionBannerNodeActions = {
  onClick?: MasonryEngineNodeAction;
};

export type RegionBannerNode = MasonryEngineNode<
  'regionBanner',
  RegionBannerNodeProps,
  RegionBannerNodeActions
>;

export type RegionBannerRendererProps =
  MasonryEngineNodeRendererProps<RegionBannerNode>;

export const RegionBannerHomeRenderer = ({
  onClick,
}: RegionBannerRendererProps) => {
  // Invoke the onClick action (analytics) received from the masonry config
  const invokeAction = useMasonryEngineActionEmitter();
  const handleOnClick = useCallback(() => {
    if (onClick) invokeAction(onClick);
  }, [invokeAction, onClick]);

  return <RegionSelectionHome onClick={handleOnClick} />;
};
